import React, { FunctionComponent } from "react"
import { SchemaField } from "../featuer-layer-settings/schema"
import { TextField } from "./TextField"
import { BooleanField } from "./BooleanField"
import { MarkdownField } from "./MarkdownField"
import { ImageUploadField } from "./ImageUploadField"
import { SelectField } from "./SelectField"

/** RenderField component props */
export interface RenderFieldProps {
  field: SchemaField
}

/**
 * Decides which field to render based on the variant
 */
export const RenderField: FunctionComponent<RenderFieldProps> = ({ field }) => {
  switch (field.variant) {
    case "switch":
      return <BooleanField field={field} />
    case "markdown":
      return <MarkdownField field={field} />
    case "imageUpload":
      return <ImageUploadField field={field} />
    case "select":
      return <SelectField field={field} />
    case "multiline":
    case "text":
    default:
      return <TextField field={field} />
  }
}
